exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textarea {\n  margin-bottom: 1em; }\n\n.error {\n  color: red; }\n\n.success {\n  color: green; }\n\n.textareaContainer {\n  width: 50%;\n  overflow: hidden;\n  margin: 0 2em; }\n\n.ml-1 {\n  margin-left: 1em; }\n\n@media (max-width: 1400px) {\n  .textareaContainer {\n    width: 70%; } }\n\n@media (max-width: 1000px) {\n  .textareaContainer {\n    width: inherit; }\n    .textareaContainer textarea {\n      min-height: 60vh; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/component/regulatory-information/style.scss
// module id = 1498
// module chunks = 0